import { Column, DataTable } from "@/components/data-table"
import PrintContainer from "./container"
import { formatDate } from "@/shared/formats"
import dayjs from "dayjs"
import { extractText } from "@/shared/utils"
import { Filter, useFiltersReturn } from "@/components/filters"
import { ReactNode } from "react"

interface PrintComponentProps {
    title: string,
    description: string,
    data: any[]
    filterData: useFiltersReturn,
    columns: Column[],
    additionalData?: Record<string, any>,
    additionalDisplay?: { label: ReactNode, value: ReactNode }[]
}

export default function PrintComponent({
    title,
    description,
    data,
    columns,
    filterData,
    additionalData = {},
    additionalDisplay
}: PrintComponentProps) {
    const renderLabel = (filter: Filter) => {
        switch (filter.type) {
            case "string":
                return `${filter.label} con "${filter.value}"`;
            case "select":
                return `${filter.label} = ${filter.selectedOption ? filter.selectedOption.label : filter.value}`;
            case "dateRange":
                if (filter.fromActive && filter.toActive) return `${filter.label} entre ${formatDate(filter.from)} y ${formatDate(dayjs(filter.to).subtract(1, "day"))}`;
                else if (filter.fromActive) return `${filter.label} después del ${formatDate(filter.from)}`;
                else return `${filter.label} antes del ${formatDate(dayjs(filter.to).subtract(1, "day"))}`;
            case "model":
                const data = additionalData[filter.name];
                return `${filter.label} = ${data && data[filter.labelName] ? data[filter.labelName] : "???"}`
            default:
                return "";
        }
    }

    const getCriteria = () => {
        return filterData.filters.filter(filter => filter.active).map(renderLabel);
    }

    return <PrintContainer>
        <PrintContainer.Header
            title={title}
            description={description}
            criteria={getCriteria()}
            additionalDisplay={additionalDisplay}
        />
        <DataTable>
            <DataTable.Content
                rows={data}
                columns={columns.map(c => ({
                    ...c,
                    render: (r, i) => extractText(c.render(r, i)),
                    header: extractText(c.header)
                }))}
                emptyText=""
            />
        </DataTable>
    </PrintContainer>
}